import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets a string that uniquely identifies an order. It can be used to create more human-readable (in contrast to ID) identifier for the order.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setOrderNumber"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`orderNumber`}</inlineCode>{` - String - Optional`}<br parentName="li"></br>
          {`It should be `}<strong parentName="li">{`unique`}</strong>{` across a project. Once it's set, it cannot be changed.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      